// third-party

import { Box, Skeleton, TableCell, TableRow } from '@mui/material';

// project import

// Interface
interface ISkeletonRowTransactionDepositProps {}

// ==============================|| SkeletonRowTransactionDeposit ||============================== //

const SkeletonRowTransactionDeposit = (props: ISkeletonRowTransactionDepositProps) => {
    return (
        <TableRow sx={{ width: '100%' }}>
            <TableCell component="td" scope="col" sx={{ width: '15%' }}>
                <Skeleton variant="rectangular" width={60} height={18} animation="wave" />
            </TableCell>
            <TableCell component="td" scope="col" sx={{ textTransform: 'capitalize', width: '15%' }}>
                <Skeleton variant="rectangular" width={60} height={18} animation="wave" />
            </TableCell>

            <TableCell component="td" scope="col" sx={{ width: '15%' }} size="medium">
                <Box display="flex" alignItems="center" gap={2}>
                    <Skeleton variant="rectangular" width={30} height={18} animation="wave" />
                    <Skeleton variant="circular" width={24} height={24} animation="wave" />
                </Box>
            </TableCell>
            <TableCell component="td" scope="col" sx={{ width: '15%' }}>
                <Skeleton variant="rectangular" width={80} height={18} animation="wave" />
            </TableCell>
            <TableCell component="td" scope="col" sx={{ width: '15%' }}>
                <Skeleton variant="rectangular" width={100} height={18} animation="wave" />
            </TableCell>
            <TableCell component="td" scope="col" sx={{ width: '15%' }}>
                <Skeleton variant="rectangular" width={100} height={18} animation="wave" />
            </TableCell>
            <TableCell component="td" scope="col" sx={{ textTransform: 'capitalize', width: '10%' }}>
                <Skeleton variant="rectangular" width={60} height={18} animation="wave" />
            </TableCell>
        </TableRow>
    );
};

export default SkeletonRowTransactionDeposit;
